// extracted by mini-css-extract-plugin
export default {"emailRow":"ztuYVx9b","email":"JzaAKceN","withHover":"i1rEjaMn","icon":"Pisg7Thl","mailOutlinedContainer":"ISh2qBkD"};